module.exports = __webpack_public_path__ + "img/payfitIO.264eeffd.png";